var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1393_4413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1406 26.75C47.1406 25.8439 46.4061 25.1094 45.5 25.1094C44.5939 25.1094 43.8594 25.8439 43.8594 26.75C43.8594 35.4949 36.7449 42.6094 28 42.6094C19.2551 42.6094 12.1406 35.4949 12.1406 26.75C12.1406 25.8439 11.4061 25.1094 10.5 25.1094C9.59394 25.1094 8.85938 25.8439 8.85938 26.75C8.85938 36.7515 16.5704 44.9846 26.3594 45.8195V53.2188H17.5C16.5939 53.2188 15.8594 53.9533 15.8594 54.8594C15.8594 55.7654 16.5939 56.5 17.5 56.5H38.5C39.4061 56.5 40.1406 55.7654 40.1406 54.8594C40.1406 53.9533 39.4061 53.2188 38.5 53.2188H29.6406V45.8195C39.4296 44.9846 47.1406 36.7515 47.1406 26.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.125 28.3906C33.2189 28.3906 32.4844 27.6561 32.4844 26.75C32.4844 25.8439 33.2189 25.1094 34.125 25.1094H40.1406V21.3906H32.375C31.4689 21.3906 30.7344 20.6561 30.7344 19.75C30.7344 18.8439 31.4689 18.1094 32.375 18.1094H40.1406V14.3906H34.125C33.2189 14.3906 32.4844 13.6561 32.4844 12.75C32.4844 11.8439 33.2189 11.1094 34.125 11.1094H40.0988C39.6022 5.17556 34.6603 0.5 28.6562 0.5H27.3438C21.3397 0.5 16.3977 5.17567 15.901 11.1094H21.875C22.7811 11.1094 23.5156 11.8439 23.5156 12.75C23.5156 13.6561 22.7811 14.3906 21.875 14.3906H15.8594V18.1094H23.625C24.5311 18.1094 25.2656 18.8439 25.2656 19.75C25.2656 20.6561 24.5311 21.3906 23.625 21.3906H15.8594V25.1094H21.875C22.7811 25.1094 23.5156 25.8439 23.5156 26.75C23.5156 27.6561 22.7811 28.3906 21.875 28.3906H15.902C16.4031 34.2641 21.3429 38.8906 27.3438 38.8906H28.6562C34.6571 38.8906 39.5969 34.2641 40.098 28.3906H34.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1393_4413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.4aefacc7443376b6294e3431953f27bb.svg";
export { ForwardRef as ReactComponent };